import { CommonModule, DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { Ope } from "src/app/models/Ope";
import { OptionResponseDto } from "src/app/models/OptionResponseDto";
import { collabService } from "src/app/services/collab/collabService.service";
import { OptionServices } from "src/app/services/options/option.service";
import { shareOpeSevices } from "src/app/services/sharedservices/shareOpe.services";

@Component({

  selector: 'app-programme-options',
  templateUrl: './programme-options.component.html',
  imports: [CommonModule,TableModule,FormsModule,DatePipe],
  styleUrls: ['./programme-options.component.scss']
})

export class ProgrammeOptionsComponent implements OnInit {


  programmeseled!: Ope;

  options!: OptionResponseDto[];
  constructor(private readonly collab: collabService, public share: shareOpeSevices, private readonly optionService: OptionServices) { }

  ngOnInit() {
    this.populate();
  }

  populate() {



    this.share.datasOpe$.subscribe(data => this.programmeseled = data);
    this.optionService.getOptionByProgramme(this.programmeseled.numOpeExt).subscribe((data) => {
      this.options = data;


    });

    this.share.dataOptions$.subscribe((data) => {
      this.options = data;

    });
  }



}
